import { FC, useEffect, useRef } from "react";
import { Tooltip } from "bootstrap";
import style from "./style.module.scss";

type ExpirationTooltipProps = {
  expirationDays: number;
  formattedExpirationDate: string;
};

// PRE: render condition: expirationdays <= 20
export const ExpirationTooltip: FC<ExpirationTooltipProps> = (props) => {
  const { expirationDays, formattedExpirationDate } = props;
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref?.current) {
      new Tooltip(ref.current);
    }
  }, [ref]);

  return (
    <div
      ref={ref}
      tabIndex={0}
      data-bs-toggle="tooltip"
      data-bs-title={
        expirationDays > 1
          ? `Questo file scade tra ${expirationDays} giorni
          (il ${formattedExpirationDate})`
          : expirationDays === 1
          ? "Questo file scade domani"
          : "Questo file scade oggi"
      }
      data-bs-custom-class={style["custom-tooltip"]}
    >
      <i
        className={`bi bi-exclamation-circle ${
          expirationDays > 3 ? "text-warning" : "text-danger"
        }`}
      ></i>
    </div>
  );
};
